import DynamikOverview from '../../dynamikModul/Modules/Pages/overview'
import React from 'react'
import {
    ResponseOverview,
    ResponseDelete,
    ResponseDetail
} from './API/response/Type/customizer'
import DynamikDeleted from '../../dynamikModul/Modules/Pages/deleted'
import DynamikDetail from '../../dynamikModul/Modules/Pages/detail'
import DynamikNew from '../../dynamikModul/Modules/Pages/new'
import CardJSX from './configuration/card'
import SearchConfig from './configuration/SearchConfig'
import { destination, link } from './helper/const'
import table from './configuration/table'
import Forms from './configuration/Form'

export const Payment_ReminderPagesConfig = (value: any) => {
    return [
        {
            path: '/payment_reminder/overview/:page',
            elements: (
                <DynamikOverview
                    value={value}
                    table={table}
                    destination={destination}
                    state={'ewiv'}
                    SearchConfig={SearchConfig(destination)}
                    CardsConfiguration={CardJSX(link, destination)}
                    response={ResponseOverview}
                    dynamik={false}
                    nonewButton={true}
                    buttonText={'EWIV '}
                />
            ),
            roles: ['superadmin', 'admin']
        },
        {
            path: '/payment_reminder/Delete/:page/:deleteID',
            elements: (
                <DynamikDeleted
                    value={value}
                    reponse={ResponseDelete}
                    namespace={destination}
                />
            ),
            roles: ['superadmin', 'admin']
        },
        {
            path: '/payment_reminder/new/new',
            elements: (
                <DynamikNew
                    value={value}
                    forms={Forms}
                    namespace={'/' + destination + '/overview/1'}
                    saveRoute={'company/ewiv/0/'}
                />
            ),
            roles: ['superadmin', 'admin']
        },
        {
            path: '/payment_reminder/new/:page',
            elements: (
                <DynamikNew
                    value={value}
                    forms={Forms}
                    namespace={'/' + destination + '/overview/1'}
                    saveRoute={'company/ewiv/0/'}
                />
            ),
            roles: ['superadmin', 'admin']
        },
        {
            path: '/payment_reminder/Detail/:id',
            elements: (
                <DynamikDetail
                    value={value}
                    forms={Forms}
                    response={ResponseDetail}
                    saveRoute={'company/ewiv/'}
                />
            ),
            roles: ['superadmin', 'admin']
        }
    ]
}

export const Payment_ReminderMenuConfig = (value: any) => {
    return [
        {
            name: 'Mahnlauf',
            route: '/payment_reminder/overview/1',
            icon: 'account_balance',
            roles: ['superadmin', 'admin']
        }
    ]
}

export const Payment_ReminderDasboard = () => [
    {
        title: 'Mahnlauf',
        href: '/payment_reminder/overview/1',
        undertitle: 'Backoffice',
        icon: 'account_balance',
        text: 'EWIV',
        roles: ['superadmin', 'admin']
    }
]
